var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('edit')}},[_c('BaseButton',{staticClass:"edit btn-link",attrs:{"type":"warning","size":_vm.size,"icon":""},on:{"click":_vm.click}},[_c('i',{staticClass:"fas fa-edit"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }